import { apiInterceptor } from 'utils/apiInterceptor';
/**
 * Get the details of blocks and widgets present on a livepage
 * @param  {string} searchQuery
 * @category Venue Builder
 */
const getPeopleDetails = async (projectId, srchVal) => {
    try {
        const response = await apiInterceptor(
            `${process.env.REACT_APP_MYXP_API}/manager/livestream/projects/${projectId}/getPeople?environment=${process.env.REACT_APP_ENVIRONMENT}&search=${srchVal}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        return await response.json();
    } catch (error) {
        console.error(error);
        throw error;
    }
};
export default getPeopleDetails;
